import Filter from './filter';
import {FILTER_TYPE_BOOL} from 'src/js/lib/filtering/filters_definitions_constants';

class BoolFilter extends Filter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_BOOL;
  }

  static fromString(serializedFilter) {
    const nameValueSepIdx = serializedFilter.indexOf(':');
    const property = serializedFilter.slice(0, nameValueSepIdx);
    // remove parenthesis

    if (serializedFilter.slice(nameValueSepIdx + 1) === '*') {
      return new BoolFilter({property, value: null});
    }
    const value = serializedFilter.slice(nameValueSepIdx + 2, -1);
    return new BoolFilter({property, value});
  }

  static fromSchema(schemaNode, parentName) {
    return new BoolFilter({property: parentName, value: schemaNode.getName()});
  }

  clone() {
    return new BoolFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  getValue() {
    return !!this.value;
  }

  isEqual(otherFilter) {
    return (
      this.property === otherFilter.property && this.value === otherFilter.value
    );
  }

  toString() {
    if (this.value != null) {
      return `${this.property}:'${this.value}'`;
    }
    return `${this.property}:*`;
  }

  toComponentString(filterSchema, translateService) {
    const node = filterSchema
      ? filterSchema.getFilterByName(this.property)
      : undefined;
    if (node) {
      const label = translateService
        ? translateService.formatMessage({id: node.getLabel()})
        : node.getLabel();
      const childLabel = translateService
        ? translateService.formatMessage({
            id: node.getChildLabel(filterSchema, this.value),
          })
        : node.getChildLabel(filterSchema, this.value);
      return `${label}: ${childLabel}`;
    }
    return `${this.value}`;
  }
}

export default BoolFilter;
